var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 0C2.91 0 0 2.91031 0 6.5C0 10.09 2.91 13 6.5 13C10.0897 13 13 10.09 13 6.5C13 2.91031 10.0897 0 6.5 0ZM9.41187 8.57801C9.62437 8.79019 9.62437 9.13449 9.41187 9.34698L9.34683 9.41234C9.13434 9.62452 8.79003 9.62452 8.57754 9.41234L6.5 7.33418L4.42199 9.41219C4.20981 9.62437 3.86551 9.62437 3.65302 9.41219L3.58766 9.34683C3.37548 9.13434 3.37548 8.79003 3.58766 8.57786L5.66582 6.5L3.58781 4.4223C3.37563 4.20981 3.37563 3.86551 3.58781 3.65302L3.65317 3.58797C3.86566 3.37548 4.20997 3.37548 4.42214 3.58797L6.5 5.66582L8.5777 3.58813C8.79019 3.37563 9.13449 3.37563 9.34698 3.58813L9.41203 3.65317C9.62452 3.86566 9.62452 4.20997 9.41203 4.42246L7.33418 6.5L9.41187 8.57801Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon2);
export default __webpack_public_path__ + "static/media/closeIcon2.f8dbccc502a7f26ece1abaa1bb495ee9.svg";
export { ForwardRef as ReactComponent };